import React, { useState, useEffect } from 'react';
import { makeStyles } from '@mui/styles';

import { CustomersToolbar, CustomersTable } from './components';

import CircularProgress from '@mui/material/CircularProgress';
import { Alert } from '@mui/material';

import { useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { fetchCustomers } from 'store/actions/restaurant';

import { authMiddleWare } from 'util/auth'

import { useQuery } from '@tanstack/react-query';
import { getCustomers } from 'apis/userAPIs';


const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  content: {
    marginTop: theme.spacing(2)
  },
  uiProgess: {
		position: 'fixed',
		zIndex: '1000',
		height: '31px',
		width: '31px',
		left: '50%',
		top: '35%'
	}
}));



const CustomerList = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  authMiddleWare(history);

  const loadCustomers = (allCustomer) => dispatch(fetchCustomers(allCustomer));

  // React Query hook for fetching customers
  const {
    data: customersList = [],
    isLoading,
    isError,
    error,
    refetch
  } = useQuery({
    queryKey: ['customers'],
    queryFn: getCustomers,
    retry: 2,
    staleTime: 5 * 60 * 1000, // 5 minutes
    onSuccess: (data) => {
      // Update Redux store for backward compatibility
      loadCustomers(data);
    },
    onError: (error) => {
      console.log('Error fetching customers:', error);
      if (error.response && error.response.status === 403) {
        history.push('/sign-in');
      }
    }
  });


  if (isError) {
    return (
      <main className={classes.content}>
        <Alert severity="error">
          {error?.response?.data?.message || 'Error in retrieving the data'}
        </Alert>
      </main>
    );
  }

  if (isLoading) {
    return (
      <main className={classes.content}>
        <CircularProgress size={150} className={classes.uiProgess} />
      </main>
    );
  }

  return (
    <div className={classes.root}>
      <CustomersToolbar customers={customersList}/>
      <div className={classes.content}>
        <CustomersTable customers={customersList} />
      </div>
    </div>
  );
};

export default CustomerList;
